// Copyright (c) 2016 Deere & Company

import RegistrationStatus, {getDefaultState} from '../state/registration-status';
import actions from '../../actions-list';
import {updateKeyValueSelectionList} from '../../../shared/services/list-selections';

const readRegistrationStatus = (state, action) => {

    const allowedStatuses = action.data;

    return RegistrationStatus.update(state, {
        allowed: {
            $set: allowedStatuses
        }
    });

};

const selectAllRegistrationStatuses = state => {

    const toggleSelectedStatusesState = state.selected.length > 0 ? [] : state.allowed;

    return RegistrationStatus.update(state, {
        selected: {
            $set: toggleSelectedStatusesState
        }
    });

};

const selectRegistrationStatus = (state, action) =>
    RegistrationStatus.update(state, {
        selected: {
            $set: updateKeyValueSelectionList(
                action.status,
                action.isSelected,
                state.selected
            )
        }
    });

const reset = state =>
    RegistrationStatus.update(state, {
        selected: {
            $set: getDefaultState().selected
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_REGISTRATION_STATUSES_SUCCESS]: readRegistrationStatus,
        [actions.RESET_REGISTRATIONS_REVIEW_CRITERIA]: reset,
        [actions.SELECT_ALL_REGISTRATIONS_REVIEW_REGISTRATIONS_STATUSES]: selectAllRegistrationStatuses,
        [actions.SELECT_REGISTRATIONS_REVIEW_REGISTRATION_STATUS]: selectRegistrationStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/reports/registrations-review/reducers/registration-status.js